export default {
  namespaced: true,
  state: {
    data: [
      {
        key: 'plans-impact-price',
        value: 29.00,
      },
      {
        key: 'plans-exact-price',
        value: 299.00,
      },
      {
        key: 'plans-premium-price',
        value: 699.00,
      },
      {
        key: 'plans-elite-price',
        value: 2599.00,
      },
    ],
  },
  mutations: {

  },
  actions: {

  },
  getters: {


    get: state => key => {
      const variable = state.data.find(n => n.key === key);
      if(variable) {
        return variable['value'];
      }
    },


    data(state) {
      return state.data
    },
  }
}
